import React from "react";
import classNames from "classnames";

type Props = {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  value: string | number;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
};

const Option = ({ children, className, disabled, value, ...others }: Props) => {
  const classes = classNames(className);

  return (
    <option className={classes} disabled={disabled} value={value} {...others}>
      {children}
    </option>
  );
};

export default Option;
